<template>
  <v-app class="app-tabela">
    <div class="box" style="margin-top: 0px">
      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nome"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          @pagination="getPagination"
          :page="currentPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :items="indexedItems"
          :item-class="getRowColor"
          :search="search"
          :single-expand="true"
          :expanded.sync="expanded"
          item-key="id"
          show-expand
          class="elevation-1"
          @item-expanded="onItemExpanded"
        >
          <!-- <template #footer.prepend>
          <v-spacer />
        </template> -->
          <template v-slot:[`footer.page-text`]="items">
            <div class="info-table-item tabela-esus-pec">
              <FonteSincronizadorC />
            </div>
            <span class="paginacao"
              >{{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }} pessoas</span
            >
          </template>
          <template v-slot:header.micro_area="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Microárea do ACS"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>
          <template v-slot:header.total_bp="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Data do último atendimento e percentual da(s) boa(s) prática(s) aplicável(is) realizada(s) na criança."
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <template v-slot:item.dt_nascimento="{ item }">
            {{
              item.dt_nascimento != null ? formatDate(item.dt_nascimento) : ''
            }}
            <br />
            ({{ Math.floor(item.idade_dias / 30) }}
            {{ Math.floor(item.idade_dias / 30) > 1 ? 'meses' : 'mês' }})
          </template>

          <template v-slot:item.total_bp="{ item }">
            {{ item.ult_atend != null ? formatDate(item.ult_atend) : '' }}
            <br />
            <span>({{ item.total_bp ?? 0 }}%)</span>
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td colspan="9">
              <table class="table table-interna">
                <thead>
                  <tr>
                    <th>CPF</th>
                    <th>CNS</th>
                    <th>Microárea</th>
                    <th>Cadastrado por</th>
                    <th v-if="exibirCopilot">Suporte</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ item.nu_cpf }}</td>
                    <td>{{ item.nu_cns }}</td>
                    <td>{{ item.micro_area }}</td>
                    <td>{{ item.no_profissional }}</td>
                    <td v-if="exibirCopilot">
                      <copilot :item="item" :rules="item.rules"></copilot>
                    </td>
                  </tr>
                </tbody>
              </table>

              <table class="table table-interna table-boas-praticas">
                <thead>
                  <tr>
                    <th>
                      Primeira consulta
                      <span
                        v-b-tooltip.hover.right
                        title="(A) Ter a 1ª consulta presencial realizada por médica(o) ou enfermeira(o), até o 30º dia de
vida."
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </th>
                    <th>
                      Consultas
                      <span
                        v-b-tooltip.hover.right
                        title="(B) Ter pelo menos 09 (nove) consultas presenciais ou remotas realizadas por médica(o) ou
enfermeira(o) até dois anos de vida."
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </th>
                    <th>
                      Peso e altura
                      <span
                        v-b-tooltip.hover.right
                        title="(C) Ter pelo menos 09 (nove) registros simultâneos de peso e altura até os dois anos de
vida."
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </th>
                    <th>
                      Visitas
                      <span
                        v-b-tooltip.hover.right
                        title="(D) Ter pelo menos 02 (duas) visitas domiciliares realizadas por ACS/TACS, sendo a primeira
até os primeiros 30 (trinta) dias de vida e a segunda até os 06 (seis) meses de vida."
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </th>
                    <th>
                      Vacinas
                      <span
                        v-b-tooltip.hover.right
                        title="(E) Ter vacinas contra difteria, tétano, coqueluche, hepatite B, infecções causadas por
Haemophilus influenzae tipo b, poliomielite, sarampo, caxumba e rubéola, pneumocócica, registradas com todas as doses recomendadas."
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div
                        class="table-boas-praticas-item"
                        :class="
                          item.a_pb == null || item.a_pb == 0 ? 'red' : 'green'
                        "
                        @click="openModal('primeira-consulta', item)"
                      >
                        {{ item.a_pb ?? 0 }}
                        pontos
                      </div>
                    </td>
                    <td>
                      <div
                        class="table-boas-praticas-item"
                        :class="
                          item.b_pb == null || item.b_pb == 0 ? 'red' : 'green'
                        "
                        @click="openModal('consultas', item)"
                      >
                        {{
                          getTextButtonBoaPratica(
                            item.b_pb,
                            item.idade_dias,
                            'consultas'
                          )
                        }}
                      </div>
                    </td>
                    <td>
                      <div
                        class="table-boas-praticas-item"
                        :class="
                          item.c_pb == null || item.c_pb == 0 ? 'red' : 'green'
                        "
                        @click="openModal('peso-altura', item)"
                      >
                        {{
                          getTextButtonBoaPratica(
                            item.c_pb,
                            item.idade_dias,
                            'peso-altura'
                          )
                        }}
                      </div>
                    </td>
                    <td v-if="item.tp_ine_fci != '76'">
                      <div
                        class="table-boas-praticas-item"
                        :class="
                          item.d_pb == null || item.d_pb == 0 ? 'red' : 'green'
                        "
                        @click="openModal('visitas', item)"
                      >
                        {{
                          getTextButtonBoaPratica(item.d_pb, item.idade_dias)
                        }}
                      </div>
                    </td>
                    <td v-else>Não se aplica</td>
                    <td>
                      <div
                        class="table-boas-praticas-item"
                        :class="
                          item.e_pb == null || item.e_pb == 0 ? 'red' : 'green'
                        "
                        @click="openModal('vacinas', item)"
                      >
                        {{
                          getTextButtonBoaPratica(item.e_pb, item.idade_dias)
                        }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <b-alert
                v-if="item.a_pb == null || item.a_pb == 0"
                variant="danger"
                show
              >
                <div class="d-flex align-center justify-space-between">
                  Criança sem 1ª consulta presencial médica ou de enfermagem até
                  o 30º dia de vida.
                  <span v-if="item.idade_meses > 0" class="fora-do-prazo"
                    >Fora do prazo</span
                  >
                </div>
              </b-alert>

              <b-alert
                v-if="item.b_pb == null || item.b_pb == 0"
                variant="danger"
                show
              >
                Criança deveria ter {{ item.qtd_atends_pes_alts }} consultas
                (medicina + enfermagem) até o momento.
              </b-alert>

              <b-alert
                v-if="item.c_pb == null || item.c_pb == 0"
                variant="danger"
                show
              >
                Criança deveria ter {{ item.qtd_atends_pes_alts }} medições de
                peso e altura até o momento.
              </b-alert>

              <b-alert
                v-if="
                  (item.d_pb == null || item.d_pb == 0) && item.idade_meses == 0
                "
                variant="danger"
                show
                >O recém-nascido deveria ter recebido pelo menos uma visita
                domiciliar do ACS/TACS até completar 30 dias de vida.
              </b-alert>

              <b-alert
                v-if="
                  (item.d_pb == null || item.d_pb == 0) && item.idade_meses > 0
                "
                variant="danger"
                show
              >
                <div class="d-flex align-center justify-space-between">
                  A criança deveria ter recebido a 2ª visita domiciliar do
                  ACS/TACS entre 30 dias e 6 meses de vida.
                  <span
                    v-if="item.idade_meses > 0 || item.idade_meses > 6"
                    class="fora-do-prazo"
                    >Fora do prazo</span
                  >
                </div>
              </b-alert>

              <b-alert
                v-if="item.e_pb == null || item.e_pb == 0"
                variant="danger"
                show
                >Criança deveria ter sido vacinada contra difteria, tétano,
                coqueluche, hepatite B, infecções causadas por Haemophilus
                Influenzae tipo B, poliomielite, sarampo, caxumba e rubéola, com
                todas as doses recomendadas.
              </b-alert>
            </td>
          </template>
          <template v-slot:progress>
            <v-progress-linear
              color="blue"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
        </v-data-table>
      </v-card>

      <b-modal
        id="modal-desenvolvimento-infantil"
        ref="modal"
        title=""
        v-model="modal.show"
        centered
        scrollable
        hide-footer
        size="lg"
      >
        <template #modal-title>
          <div v-html="modal.title"></div>
        </template>
        <div
          class="modal-desenvolvimento-infantil-body"
          v-if="modal.item != null"
        >
          <table
            class="table table-interna"
            v-if="modal.table.headers.length > 0"
          >
            <thead>
              <tr>
                <th
                  v-for="(itemHeader, indexHeader) in modal.table.headers"
                  :key="indexHeader"
                >
                  {{ itemHeader.label }}
                  <span
                    v-if="itemHeader.icon.show == true"
                    v-b-tooltip.hover.top
                    :title="itemHeader.icon.text"
                    class="icon-tooltip"
                  >
                    <i class="icofont-info-circle"></i>
                  </span>
                </th>
              </tr>
            </thead>
            <!-- Primeira consulta -->
            <tbody v-if="modal.tipo == 'primeira-consulta'">
              <tr
                v-for="(item, index) in getPrimeiraConsulta(modal.item.fai)"
                :key="index"
              >
                <td>{{ index + 1 }}</td>
                <td>{{ formatDate(item.dt_atendimento) ?? '' }}</td>
                <td>
                  {{ item.nu_cbo ?? '' }}
                  <span
                    v-b-tooltip.hover.top
                    :title="item.no_cbo"
                    class="icon-tooltip"
                  >
                    <i class="icofont-info-circle"></i>
                  </span>
                </td>
                <td>
                  {{ item.dias_decorridos }}
                  {{ item.dias_decorridos == 1 ? 'dia' : 'dias' }}
                </td>
              </tr>
            </tbody>
            <!-- Consultas -->
            <tbody v-if="modal.tipo == 'consultas'">
              <tr
                v-for="(item, index) in JSON.parse(modal.item.fai)"
                :key="index"
              >
                <td>{{ index + 1 }}</td>
                <td>{{ formatDate(item.dt_atendimento) ?? '' }}</td>
                <td>
                  {{ item.nu_cbo ?? '' }}
                  <span
                    v-b-tooltip.hover.top
                    :title="item.no_cbo"
                    class="icon-tooltip"
                  >
                    <i class="icofont-info-circle"></i>
                  </span>
                </td>
                <td>
                  {{ Math.floor(Number(item.dias_decorridos) / 30) }}
                  {{
                    Math.floor(Number(item.dias_decorridos) / 30) == 1
                      ? 'mês'
                      : 'meses'
                  }}
                </td>
              </tr>
            </tbody>
            <!-- Peso e altura -->
            <tbody v-if="modal.tipo == 'peso-altura'">
              <tr
                v-for="(item, index) in JSON.parse(modal.item.peso_altura)"
                :key="index"
              >
                <td>{{ index + 1 }}</td>
                <td>{{ formatDate(item.dt_procedimento) ?? '' }}</td>
                <td>
                  {{ item.peso ?? '' }}
                </td>
                <td>
                  {{ item.altura ?? '' }}
                </td>
                <td>
                  {{ item.nu_cbo ?? '' }}
                  <span
                    v-if="item.nu_cbo != null"
                    v-b-tooltip.hover.top
                    :title="item.no_cbo"
                    class="icon-tooltip"
                  >
                    <i class="icofont-info-circle"></i>
                  </span>
                </td>
                <td>
                  {{ item.mi ?? '' }}
                </td>
              </tr>
            </tbody>
            <!-- Visitas -->
            <tbody v-if="modal.tipo == 'visitas'">
              <tr
                v-for="(item, index) in JSON.parse(modal.item.fvdt)"
                :key="index"
                :class="
                  (item.dias_nasc_ate_visita >= 2 &&
                    item.dias_nasc_ate_visita <= 30) ||
                  (item.dias_nasc_ate_visita >= 31 &&
                    item.dias_nasc_ate_visita <= 182)
                    ? 'green'
                    : ''
                "
              >
                <td>{{ index + 1 }}</td>
                <td>{{ formatDate(item.dt_visita) ?? '' }}</td>
                <td>{{ item.motivo_acomp }}</td>
                <td>
                  {{ item.desfecho ?? '' }}
                </td>
                <td>
                  <div v-if="item.dias_nasc_ate_visita != null">
                    {{ item.dias_nasc_ate_visita }}
                    {{ item.dias_nasc_ate_visita == 1 ? 'dia' : 'dias' }}
                    ou
                    {{ Math.floor(Number(item.dias_nasc_ate_visita) / 30) }}
                    {{
                      Math.floor(Number(item.dias_nasc_ate_visita) / 30) == 1
                        ? 'mês'
                        : 'meses'
                    }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- Vacinas -->
          <div v-if="modal.tipo == 'vacinas'">
            <vacinas
              title="Pentavalente"
              :doses="modal.item.coresPentaValente"
              :cidadao="modal.item"
              @disabled-btn-processar="submitProcessar.disabled = !!$event"
              @show-alert-processar="submitProcessar.alert.show = !!$event"
            ></vacinas>
            <vacinas
              title="Vip"
              :doses="modal.item.coresVip"
              :cidadao="modal.item"
              @disabled-btn-processar="submitProcessar.disabled = !!$event"
              @show-alert-processar="submitProcessar.alert.show = !!$event"
            ></vacinas>
            <vacinas
              title="Pneumocócica 10V (conjugada)"
              :doses="modal.item.coresPneumococica"
              :cidadao="modal.item"
              @disabled-btn-processar="submitProcessar.disabled = !!$event"
              @show-alert-processar="submitProcessar.alert.show = !!$event"
            ></vacinas>
            <vacinas
              title="Tríplice viral SRC"
              :doses="modal.item.coresSrc"
              :cidadao="modal.item"
              @disabled-btn-processar="submitProcessar.disabled = !!$event"
              @show-alert-processar="submitProcessar.alert.show = !!$event"
            ></vacinas>

            <div class="d-flex align-items-center justify-content-end">
              <!-- input de arquivo escondido -->
              <input
                ref="inputPdf"
                type="file"
                accept="application/pdf"
                style="display: none"
                @change="onPdfSelected"
              />

              <!-- Botão Importar PDF -->
              <!-- <button
                class="btn btn-secondary mr-2"
                @click="triggerPdfSelect"
                :disabled="submitProcessar.loading || uploadPdf.loading"
              >
                Importar PDF
                <b-spinner
                  small
                  label="Carregando"
                  variant="white"
                  v-if="uploadPdf.loading"
                />
              </button> -->

              <!-- Botão Processar todas  -->

              <button
                class="btn btn-processar"
                @click="processarVacinas()"
                :disabled="submitProcessar.loading || submitProcessar.disabled"
              >
                Processar todas
                <b-spinner
                  small
                  label="Small Spinner"
                  variant="white"
                  v-if="submitProcessar.loading"
                />
              </button>
            </div>

            <b-alert
              class="mt-4"
              :show="submitProcessar.alert.show"
              :variant="submitProcessar.alert.type"
              >{{ submitProcessar.alert.text }}</b-alert
            >
          </div>
        </div>
      </b-modal>
    </div>
  </v-app>
</template>

<script>
import Vue from 'vue'
import * as Functions from '../functions.js'
import utils from '@/mixins/utils.js'
import ShowHideField from '@/components/utils/ShowHideField.vue'
import Copilot from '@/components/Copilot.vue'
import { rulesCopilot } from '../copilot.js'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
validations()
import { TheMask } from 'vue-the-mask'
import Vacinas from './Vacinas'

export default {
  name: 'TabelaCadastros',
  components: {
    ShowHideField,
    Copilot,
    ValidationObserver,
    ValidationProvider,
    TheMask,
    Vacinas,
  },
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
    tipo: {
      type: String,
      default: '',
    },
  },
  mixins: [utils],
  data() {
    return {
      currentPage: 1,
      expanded: [],
      enabled: null,
      search: '',
      headers: [
        {
          text: 'Nome',
          align: 'start',
          filterable: true,
          value: 'no_cidadao',
        },
        {
          text: 'Nascimento',
          align: 'start',
          filterable: false,
          value: 'dt_nascimento',
          width: '150px',
        },
        {
          text: 'Mãe',
          align: 'start',
          filterable: false,
          value: 'no_mae',
        },
        {
          text: 'Acompanhado',
          align: 'start',
          filterable: false,
          value: 'total_bp',
          sortable: true,
          width: '200px',
        },
        { text: '', value: 'data-table-expand' },
      ],
      modal: {
        title: '',
        tipo: null,
        show: false,
        item: null,
        table: {
          headers: [],
        },
      },
      modalVacinas: {
        show: false,
        form: {
          dataAplicacao: null,
          lote: null,
          btn: {
            disabled: false,
            loading: false,
          },
        },
      },
      submitProcessar: {
        loading: false,
        alert: {
          show: false,
          type: '',
          text: '',
        },
        disabled: true,
      },
      uploadPdf: {
        loading: false,
      },
    }
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  computed: {
    exibirCopilot() {
      if (this.$store.state.infoMunicipio?.exibe_whatsapp == '1') {
        return true
      }
      return false
    },
    indexedItems() {
      if (this.cadastros !== undefined) {
        return Functions.formatarCadastrosComDoses(this.cadastros)
      }
    },
  },
  methods: {
    /**
     * Filtra os registros da tabela com base no texto de busca.
     * Considera apenas as colunas marcadas como filtráveis nos headers.
     * @param {String} search Texto digitado para pesquisa
     * @returns {Array} Lista de itens filtrados
     */
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },

    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Retorna a classe CSS da linha da tabela.
     *
     * @param {Object} item
     * @returns {String}
     */
    getRowColor(item) {
      return `table-row-color-${item.rowColor}`
    },

    /**
     * Manipula o evento de expansão de um item da tabela.
     * @param {Object} item Contexto do item expandido
     */
    async onItemExpanded(item) {
      try {
        const rules = await rulesCopilot(item.item)
        Vue.set(item.item, 'rules', rules)
      } catch (error) {
        console.error('Erro ao obter as regras:', error)
      }
    },

    /**
     * Retorna os dados da primeira consulta
     *
     * @param {Array} consultas
     */
    getPrimeiraConsulta(consultas) {
      let fai = JSON.parse(consultas)
      if (fai == null) return []
      return fai.filter((el) => Number(el.dias_decorridos) <= 30)
    },

    /**
     * Retorna o texto do botão da boa prática
     *
     * @param boaPratica
     * @param idadeDias
     * @param key
     *
     * @returns {String}
     */
    getTextButtonBoaPratica(boaPratica, idadeDias, key = '') {
      if (boaPratica > 0 && idadeDias >= 730) {
        return `${boaPratica} pontos`
      }

      if (boaPratica > 0 && idadeDias < 730) {
        return 'Em dia'
      }

      if (boaPratica === 0 && idadeDias < 730) {
        if (
          this.tipo == 'criancas' &&
          key != '' &&
          (key == 'consultas' || key == 'peso-altura')
        ) {
          return 'Insuficiente'
        }
        return 'Atrasado(a)'
      }

      if (boaPratica === 0 && idadeDias >= 730) {
        return `${boaPratica} pontos`
      }

      return ''
    },

    /**
     * Abre o modal com as informações de acordo com o tipo
     *
     * @param {String} tipo
     * @param {Object} item
     */
    openModal(tipo, item) {
      this.modal.show = true
      this.modal.item = item
      this.modal.tipo = tipo
      switch (tipo) {
        case 'primeira-consulta':
          this.modal.title = `Primeira consulta ${
            (item.a_pb == null || item.a_pb == 0) && item.idade_meses > 0
              ? '<span class="fora-do-prazo">Fora do prazo</span>'
              : ''
          }`
          this.modal.table.headers = [
            {
              label: 'N°',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Atendimento',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'CBO',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Tempo',
              icon: {
                show: true,
                text: 'Tempo decorrido da data de nascimento até a data de atendimento.',
              },
            },
          ]
          break
        case 'consultas':
          this.modal.title = 'Consultas'
          this.modal.table.headers = [
            {
              label: 'N°',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Atendimento',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'CBO',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Tempo',
              icon: {
                show: true,
                text: 'Tempo decorrido da data de nascimento até a data de atendimento.',
              },
            },
          ]
          break
        case 'visitas':
          this.modal.title = `Visitas ${
            (item.d_pb == null || item.d_pb == 0) &&
            (item.idade_meses > 0 || item.idade_meses > 6)
              ? '<span class="fora-do-prazo">Fora do prazo</span>'
              : ''
          }`
          this.modal.table.headers = [
            {
              label: 'N°',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Visita',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Motivo',
              icon: {
                show: true,
                text: 'Problema/Condição avaliada no atendimento',
              },
            },
            {
              label: 'Desfecho',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Tempo',
              icon: {
                show: true,
                text: 'Período decorrido entre o dia de nascimento e a data da visita.',
              },
            },
          ]
          break
        case 'peso-altura':
          this.modal.title = 'Peso e altura'
          this.modal.table.headers = [
            {
              label: 'N°',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Data',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Peso',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Altura',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'CBO',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'MI',
              icon: {
                show: true,
                text: 'Modelo de Informação',
              },
            },
          ]
          break
        case 'vacinas':
          this.modal.title = 'Vacinas'
          this.submitProcessar.alert.show = false
          this.modal.table.headers = []
          this.submitProcessar.disabled = true
          break
        default:
          break
      }
    },

    /**
     * Processa todas as vacinas
     */
    async processarVacinas() {
      try {
        this.submitProcessar.alert.show = false
        this.submitProcessar.loading = true

        const payloadBase = {
          co_ibge: this.$store.state.cod_ibge,
          cfcp: this.modal.item.nu_cpf ?? this.modal.item.nu_cns,
        }

        const vacinas = [
          {
            key: 'penta',
            ids: ['42', '09', '17', '29', '39', '43', '46', '47', '58'],
          },
          { key: 'vip', ids: ['22', '29', '43', '58'] },
          { key: 'vpc10', ids: ['26', '59', '106', '107'] },
          { key: 'scr', ids: ['24', '39', '56'] },
        ]

        const requests = vacinas.map((v) =>
          this.$api.post('/app/efb-vacina/processar', {
            ...payloadBase,
            key: v.key,
            ids: v.ids,
          })
        )

        const responses = await Promise.all(requests)

        const allSuccess = responses.every(
          (res) => res.data && res.data.error === false
        )

        if (allSuccess) {
          this.submitProcessar.alert.show = true
          this.submitProcessar.alert.type = 'success'
          this.submitProcessar.alert.text =
            'Processamento concluído com sucesso! Os resultados podem levar até 24 horas para serem atualizados na sincronização.'
          this.submitProcessar.disabled = true
        }
      } catch (error) {
        console.error(error)
        this.submitProcessar.alert.show = true
        this.submitProcessar.alert.type = 'danger'
        this.submitProcessar.alert.text =
          'Ocorreu um erro inesperado durante o processamento. Por favor, entre em contato com o suporte.'
      } finally {
        this.submitProcessar.loading = false
      }
    },

    /**
     * Manipula ao importar o pdf
     */
    triggerPdfSelect() {
      this.$refs.inputPdf && this.$refs.inputPdf.click()
    },

    /**
     * Manipula ao selecionar um arquivo
     * @param {File} e
     */
    async onPdfSelected(e) {
      const file = e.target.files && e.target.files[0]
      if (!file) return

      if (file.type && file.type !== 'application/pdf') {
        this.submitProcessar.alert.show = true
        this.submitProcessar.alert.type = 'danger'
        this.submitProcessar.alert.text = 'Selecione um arquivo PDF válido.'
        e.target.value = '' // reset input
        return
      }
      if (!/\.pdf$/i.test(file.name)) {
        this.submitProcessar.alert.show = true
        this.submitProcessar.alert.type = 'danger'
        this.submitProcessar.alert.text = 'O arquivo precisa ter extensão .pdf.'
        e.target.value = ''
        return
      }

      this.uploadPdf.loading = true
      this.submitProcessar.alert.show = false

      try {
        const form = new FormData()
        form.append('co_ibge', this.$store.state.cod_ibge)
        form.append('file', file)

        const res = await this.$api.post(
          '/app/utils/imunizacao/importar-vacinas/pdf',
          form,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        )

        const ok = res?.data && res.data.error === false
        this.submitProcessar.alert.show = true
        this.submitProcessar.alert.type = ok ? 'success' : 'danger'
        this.submitProcessar.alert.text = ok
          ? 'PDF importado com sucesso! Aguarde a sincronização para refletir os dados.'
          : res.data?.message || 'Falha ao importar o PDF.'
      } catch (err) {
        console.error(err)
        this.submitProcessar.alert.show = true
        this.submitProcessar.alert.type = 'danger'
        this.submitProcessar.alert.text =
          'Erro ao importar o PDF. Tente novamente.'
      } finally {
        this.uploadPdf.loading = false
        e.target.value = ''
      }
    },
  },
}
</script>

<style scoped lang="scss">
.ultimo-acompanhamento {
  display: flex;
  align-items: center;
  // flex-direction: column;
  gap: 10px;
  span {
    background: #c4e8f6;
    color: #00aeef;
    padding: 5px 10px;
    border-radius: 10px;
    font-size: 11px;
  }
}

.icon-copilot {
  img {
    background: #f7f7f7;
    color: #00aeef;
    border-radius: 10px;
    text-align: center;
    width: 40px;
    padding: 10px;
  }
}

.container-table-interna {
  height: 300px;
  overflow-y: scroll;
}

.table-boas-praticas {
  .table-boas-praticas-item {
    cursor: pointer;
    background-color: #fff;
    min-width: 120px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 10px;
    border: 1px solid #ccc;
    color: #fff;
    border-radius: 6px;
    font-size: 16px;
    text-align: center;
  }
}

.modal-desenvolvimento-infantil-body {
  .doses-list {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 10px;
    gap: 20px;
    margin: 20px 0;
    background-color: #f1f0f5;
    padding: 15px;
    h4 {
      font-size: 16px;
      margin-bottom: 0;
    }
    .doses-list-item {
      cursor: pointer;
      background-color: #fff;
      min-width: 120px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding: 10px;
      border: 1px solid #ccc;
      color: #000;
      border-radius: 6px;
      &.red {
        background: #ffb3b3 !important;
        // border-color: #990000 !important;
      }
      &.green {
        background: #b3ffb3;
        // border-color: #008000 !important;
      }
      &.white {
        background: #fff;
        // border-color: #000 !important;
      }
    }
  }

  .btn-processar {
    text-transform: initial;
  }
}
</style>
